import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserBusiness } from '@app/models/user-business';
import { environment } from '@environments/environment';

const API = environment.API;

@Injectable({
    providedIn: 'root'
})
export class UserBusinessService {
    constructor(private http: HttpClient) {}

    get(UserId) {
	// console.log('------', UserId);
    }
}
